import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { PropertyTax } from '../../model/property-tax';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { Inject, Injectable } from '@angular/core';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { Observable, finalize } from 'rxjs';
import { LocalDate } from '../../../core/model/local-date';
import { TaxTypeCode } from '../../model/tax-type-code';
import { BuildingPropertyTaxAssessment } from '../../model/building-property-tax-assesment';

@Injectable()
export class PropertyTaxService extends DataService<PropertyTax> {
  constructor(
    httpClient: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(httpClient, config, messageService, PropertyTax, progressBar, 'property');
  }

  getPropertyTaxesByYear(propertyId: string, year: number): Observable<PropertyTax[]> {
    this.progressBar.start();
    return this.client.get<PropertyTax[]>(`${this.endpoint}/property-taxes-year/${propertyId}/${year}`).pipe(
      finalize(() => {
        this.progressBar.stop();
      })
    );
  }

  getCurrentPropertyTaxes(propertyIds: string[]): Observable<PropertyTax[]> {
    this.progressBar.start();
    return this.client.post<PropertyTax[]>(`${this.endpoint}/current-property-taxes`, propertyIds).pipe(
      finalize(() => {
        this.progressBar.stop();
      })
    );
  }

  getPropertyTaxTypeCodes(): Observable<Map<number, TaxTypeCode>> {
    this.progressBar.start();
    return this.client.get<Map<number, TaxTypeCode>>(`${this.endpoint}/property-tax-type-codes`).pipe(
      finalize(() => {
        this.progressBar.stop();
      })
    );
  }
}
